import { ID } from "@/types/common"

/**
 * 角色状态枚举
 */
export enum RoleStatus {
  /** 激活 */
  ACTIVE = "ACTIVE",
  /** 未激活 */
  INACTIVE = "INACTIVE",
}

/**
 * 角色实体接口
 * API 返回/页面表格展示的完整角色实体
 */
export interface Role {
  /** 角色ID */
  id: ID
  /** 角色名称 */
  name: string
  /** 角色代码 */
  code: string
  /** 角色备注 */
  note?: string
  /** 角色状态 */
  status: RoleStatus
  /** 创建时间 */
  createdAt?: string
  /** 更新时间 */
  updatedAt?: string
}

/**
 * 角色表单数据接口
 * 表单提交用的数据结构
 */
export interface RoleFormData {
  /** 角色名称 */
  name: string
  /** 角色代码 */
  code: string
  /** 角色备注 */
  note?: string
  /** 角色状态 */
  status: RoleStatus
}

/**
 * 角色表格组件属性接口
 */
export interface RoleTableProps {
  /** 角色列表数据 */
  roles: Role[]
  /** 编辑角色回调函数 */
  onEdit: (role: Role) => void
  /** 删除角色回调函数 */
  onDelete: (id: Role["id"]) => void
  /** 加载状态 */
  loading?: boolean
  /** 已选中的角色ID列表 */
  selectedIds?: Array<Role["id"]>
  /** 选择变化回调函数 */
  onSelectionChange?: (selectedIds: Array<Role["id"]>) => void
  /** 分页信息 */
  pagination?: {
    page: number
    pageSize: number
    total: number
  }
  /** 分页变化回调 */
  onPageChange?: (page: number, pageSize: number) => void
}

/**
 * 角色信息弹窗组件属性接口
 */
export interface RoleModalProps {
  /** 弹窗是否打开 */
  isOpen: boolean
  /** 当前编辑的角色信息，为null时表示新增 */
  role: Role | null
  /** 提交加载状态 */
  loading: boolean
  /** 关闭回调函数 */
  onClose: () => void
  /** 保存回调函数 */
  onSave: (data: RoleFormData) => void
}
